export const questions = [
  {
    id: 1,
    text: "Can the student recognize their name and some environmental print (like logos or signs)?",
    tooltip: "Environmental print includes familiar logos, signs, and labels in the student's surroundings.",
    options: [
      { text: "Yes", value: "yes" },
      { text: "No", value: "no" }
    ]
  },
  {
    id: 2,
    text: "Can the student name most letter sounds?",
    tooltip: "The student can produce the most common sound for each letter when shown the letter.",
    options: [
      { text: "Yes, most or all letter sounds", value: "yes" },
      { text: "Only some letter sounds", value: "partial" },
      { text: "Very few or no letter sounds", value: "no" }
    ]
  },
  {
    id: 3,
    text: "When reading unfamiliar words, does the student use the first and last letters as clues?",
    tooltip: "For example, they might read 'dog' correctly by noticing the 'd' and 'g', but struggle with similar words like 'dig' or 'dug'.",
    options: [
      { text: "Yes, relies on first/last letters", value: "yes" },
      { text: "No, uses all letters to sound out", value: "no" },
      { text: "No, doesn't use letter sounds yet", value: "none" }
    ]
  },
  {
    id: 4,
    text: "Can the student decode simple CVC words like 'cat', 'pin', or 'mop'?",
    tooltip: "CVC words are three-letter words with a consonant, vowel, consonant pattern.",
    options: [
      { text: "Yes, consistently", value: "yes" },
      { text: "Sometimes, with effort", value: "partial" },
      { text: "No, struggles with most CVC words", value: "no" }
    ]
  },
  {
    id: 5,
    text: "Can the student segment and blend 3-4 phonemes aloud?",
    tooltip: "For example, can they break 'cat' into /c/ /a/ /t/ and blend those sounds back together?",
    options: [
      { text: "Yes, consistently", value: "yes" },
      { text: "Sometimes, with support", value: "partial" },
      { text: "No, struggles with segmenting/blending", value: "no" }
    ]
  },
  {
    id: 6,
    text: "Can the student read common irregular words like 'said', 'what', or 'they' by sight?",
    tooltip: "Sight words are words that readers recognize instantly without having to sound them out.",
    options: [
      { text: "Yes, recognizes many sight words", value: "yes" },
      { text: "Recognizes a few sight words", value: "partial" },
      { text: "No, attempts to sound them out", value: "no" }
    ]
  },
  {
    id: 7,
    text: "When spelling or reading longer words, does the student use chunks or syllables?",
    tooltip: "For example, breaking 'basket' into 'bas-ket' or recognizing common patterns like '-ing'.",
    options: [
      { text: "Yes, uses chunks/syllables", value: "yes" },
      { text: "Sometimes, with familiar words", value: "partial" },
      { text: "No, sounds out letter by letter", value: "no" }
    ]
  }
];